import { createTheme, PaletteColor, Theme, ThemeProvider, useTheme } from "@mui/material";
import { ReactNode } from "react";

const getMacros = (theme: Theme) => {
  const {
    palette: {
      accents: { green, blueDark, orangeDark },
    },
  } = theme;

  const cho: PaletteColor = {
    lighter: green[50],
    light: green[100],
    main: green[600],
    dark: green[900],
    contrastText: "#fff",
  };

  const pro: PaletteColor = {
    lighter: blueDark[50],
    light: blueDark[100],
    main: blueDark[500],
    dark: blueDark[900],
    contrastText: "#fff",
  };

  const fat: PaletteColor = {
    lighter: orangeDark[50],
    light: orangeDark[100],
    main: orangeDark[600],
    dark: orangeDark[900],
    contrastText: "#fff",
  };

  return { cho, pro, fat };
};

const getLikeDislike = (theme: Theme) => {
  const {
    palette: { success, error },
  } = theme;

  const like = success;
  const dislike = error;

  return { like, dislike };
};

export function AppThemeProvider({ children }: { children: ReactNode }) {
  const theme = useTheme();
  const {
    palette: { greyscale, success, warning, info, error },
  } = theme;
  const teamworksCalendarEvent = greyscale[300];
  const rpeLight = success;
  const rpeModerate = warning;
  const rpeHeavy = error;
  const orderStatusNew = info;
  const orderStatusCooking = warning;
  const orderStatusDone = success;
  const orderStatusCancelled = error;

  const { cho, pro, fat } = getMacros(theme);
  const { like, dislike } = getLikeDislike(theme);

  const nutritionPalette = {
    cho,
    pro,
    fat,
    like,
    dislike,
    teamworksCalendarEvent,
    rpeLight,
    rpeModerate,
    rpeHeavy,
    orderStatusNew,
    orderStatusCooking,
    orderStatusDone,
    orderStatusCancelled,
  };

  const extendedTheme = createTheme({
    ...theme,
    palette: {
      ...theme.palette,
      ...nutritionPalette,
    },
  });

  return <ThemeProvider theme={extendedTheme}>{children}</ThemeProvider>;
}
